import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import Layout from "../../../components/Layout";
import { ConfirmDelete } from "../../../components/Alert";
import swal from "sweetalert";
import { useAuth } from "../../../context/ContextApi";
import { getUserEstablishment, getEstablishmentProducts } from "../../../config/utils";
import api from "../../../config/api";

import debounce from "lodash.debounce";
import styled from "styled-components";
import InputVariation from "./components/InputVariation/InputVariation";
const ConfirmDeleteProduct = styled(ConfirmDelete)`
  .modal-dialog {
    max-width: 377px;
  }
`;
require("dotenv").config();

function ProductVariation() {
  const { userToken, userId, userEstablishment, userCategory, isPetEstablishment } = useAuth();

  const [newInputVariation, setNewInputVariation] = useState();
  const [variations, setVariations] = useState([]);
  const [deleteVariation, setDeleteVariation] = useState("");
  const [loader, setLoader] = useState(true);

  const getInputVariation = (value) => {
    setNewInputVariation(value);
  };

  const getProductVariations = async () => {
    try {
      const response = await api
        .get(`/product-variations?establishment=${userEstablishment}&paginate=true`)
        .then((res) => res.data.docs);
      setVariations(response);
    } catch (error) {
      console.log("Get Product Variations " + error);
    } finally {
      setLoader(false);
    }
  };
  const editVariation = async (value, id, variations) => {
    try {
      console.log(value, id, variations);
      const data = {
        title: value,
        variations: variations,
      };
      await api.put(`/product-variations/${id}`, data).then(() => {
        getProductVariations();
      });
    } catch (error) {
      console.log("Put Product Variations " + error);
    }
  };

  const saveVariation = async (value) => {
    setLoader(true);
    const config = {
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": `application/json`,
      },
    };
    if (value === "") {
      return;
    }
    for (let i = 0; i < variations.length; i++) {
      const variation = variations[i];
      if (value === variation.title) {
        swal({
          title: "Não é possível adicionar uma variação com o mesmo nome",
          button: "Ok, voltar",
        });
        return;
      }
    }

    try {
      const data = {
        establishment: userEstablishment,
        title: value,
        variations: [],
      };
      await api.post(`/product-variations`, data, config).then(() => {
        getProductVariations();
      });
    } catch (error) {
      console.log("Post Product Variations " + error);
    }
  };
  const removeVariation = async () => {
    try {
      await api.delete(`/product-variations/${deleteVariation}`).then(() => {
        getProductVariations();
      });
    } catch (error) {
      console.log("Delete Product Variations " + error);
    }
  };

  useEffect(() => {
    getProductVariations();
  }, [newInputVariation, variations]);

  return (
    <>
      <Layout defaultMenu={5} title={"Variações de produto"} link={""}>
        <div className="store container-fluid px-lg-1 pt-1 pb-4">
          {variations.map((variation, index) => (
            <InputVariation
              key={variation + index}
              titleVariation={variation.title}
              tagsVariation={variation.variations}
              getInputVariation={getInputVariation}
              saveVariation={saveVariation}
              variationId={variation._id}
              removeVariation={removeVariation}
              editVariation={editVariation}
              setDeleteVariation={setDeleteVariation}
              loadingVariation={loader}
            />
          ))}
          <InputVariation
            getInputVariation={getInputVariation}
            saveVariation={saveVariation}
            loadingVariation={loader}
          />
        </div>
      </Layout>
      <button
        id="btnCallConfirmDelete"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#ConfirmDeleteProduct"
      >
        Chamar modal confirm delete
      </button>
      <ConfirmDeleteProduct
        id="confirmDeleteProduct"
        onClick={removeVariation}
        title={"Tem certeza que quer excluir esta variação?"}
        text={"Excluir Variação"}
      />
    </>
  );
}

export default ProductVariation;
